import { ComponentPropsWithoutRef } from "react";
import { BlockText as IBlockText } from "~/sanity/types";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionBlockText.css";
import PortableText, { IPortableText } from "~/components/portableText/PortableText";

export type SectionBlockTextProps = ComponentPropsWithoutRef<"div"> & {
  data: IBlockText;
};

export const SectionBlockText = ({
  data,
  ...props
}: SectionBlockTextProps) => {
  return (
    <section>
      <Grid className={styles.wrapper} {...props}>
        <div className={styles.container}>
          <PortableText blocks={data.text as IPortableText} />
        </div>
      </Grid>
    </section>
  );
};
